export default __webpack_public_path__ + "static/media/down.34f126d5.svg";